
import { Component, Vue, Prop } from 'vue-property-decorator';
import lazyInject from '@/di';
import SPUService from '@/services/spu.service';
import moment, { Moment } from 'moment';

@Component({})
export default class TimedPriceChangeModal extends Vue {
  visible = false;
  title = '定时修改商品价格';

  @lazyInject(SPUService)
  protected spuService!: SPUService;

  @Prop()
  type!: string;

  moment = moment;

  sid = '';

  priceList = [
    {
      auto_price: null,
      rmb: null,
    },
  ];

  addItem() {
    this.priceList.push({
      auto_price: null,
      rmb: null,
    });
  }

  async removeItem(value: any, index: number) {
    if (value.id) {
      let res: any = '';
      const data = {
        id: value.id,
        sid: this.sid,
      };
      switch (this.type) {
        case 'platformSpu':
          res = await this.spuService.postTemplateSpuAutoPriceDel(data);
          break;
        case 'kaSpu':
          res = await this.spuService.postTemplateSpuKaAutoPriceDel(data);
          break;
        case 'leadingSpu':
          res = await this.spuService.templateSpuBaAutoPriceDel(data);
          break;
      }
      console.log(res);
      this.getList(this.sid);
      if (res) {
        this.$message.success('删除成功');
      }
    } else {
      this.priceList.splice(index, 1);
    }
  }

  cancel() {
    this.visible = false;
    this.$emit('cancel');
    this.priceList = [];
  }

  async init(id: any) {
    console.log('init', this.type);
    this.sid = id;
    await this.getList(id);
    this.visible = true;
  }

  async getList(id: any) {
    let res: any = '';
    switch (this.type) {
      case 'platformSpu':
        res = await this.spuService.templateSpuAutoPriceDetail({ sid: id });
        break;
      case 'kaSpu':
        res = await this.spuService.templateSpuKaAutoPriceDetail({ sid: id });
        break;
      case 'leadingSpu':
        res = await this.spuService.templateSpuBaAutoPriceDetail({ sid: id });
        break;
    }
    if (res.length > 0) {
      this.priceList = res.map((item: any) => ({
        ...item,
        rmb:
          item.rmb !== null && item.rmb !== undefined
            ? parseFloat((item.rmb / 100).toFixed(2))
            : null,
      }));
    } else {
      // 重置为默认一个空项
      this.priceList = [
        {
          auto_price: null,
          rmb: null,
        },
      ];
    }
  }

  onChangeTime(date: Moment) {
    console.log(date);
  }

  async submit(item: any) {
    console.log(item);
    const { id, auto_price, rmb } = item;
    if (!auto_price || !rmb) {
      this.$message.error('请填写完整信息');
      return;
    }
    const data = {
      id,
      auto_price,
      rmb,
      sid: this.sid,
    };
    let res: any = '';
    switch (this.type) {
      case 'platformSpu':
        res = await this.spuService.postTemplateSpuAutoPriceEdit(data);
        break;
      case 'kaSpu':
        res = await this.spuService.postTemplateSpuKaAutoPriceEdit(data);
        break;
      case 'leadingSpu':
        res = await this.spuService.postTemplateSpuBaAutoPriceDel(data);
        break;
    }
    if (res) {
      this.$message.success('操作成功');
      this.getList(this.sid);
    }
  }

  handleSubmit() {
    this.$emit('handleSubmit', this.priceList);
  }
}
